import { commonTexts, enrollmentTexts } from 'consts/text';
import { UsersGroup } from 'assets';
import {
    AppConfirmModal,
    AppConfirmModalProps,
} from 'components/organisms/AppConfirmModal/AppConfirmModal';
import styled from 'styled-components';

const StyledUsersGroupIcon = styled(UsersGroup)`
    width: 48px;
    height: 48px;
`;

export const EnrollmentFinishModal = ({
    open,
    onCancel,
}: Pick<AppConfirmModalProps, 'open' | 'onCancel'>) => (
    // TODO: to add mutation logic
    <AppConfirmModal
        open={open}
        isMobileFullScreenMode={false}
        // TODO: to pass loading status from useAppMutation
        // confirmActionLoading={}
        title={enrollmentTexts.finishEnrollment.title}
        text={enrollmentTexts.finishEnrollment.description}
        icon={<StyledUsersGroupIcon />}
        width={420}
        okButtonProps={{
            title: enrollmentTexts.finishEnrollment.okButtonText,
        }}
        cancelButtonProps={{ title: commonTexts.actionLabels.goBack }}
        // TODO: to pass mutate function from useAppMutation
        // onOk={}
        onCancel={onCancel}
    />
);
